// extracted by mini-css-extract-plugin
export var bold = "_6p-1";
export var container = "_6p-3";
export var deliveryIcon = "_6p-2";
export var smolText = "_6p-0";